// gatsby-browser.tsx
import "@fontsource/prompt";
// import "@fontsource/prompt/500.css";
// import "@fontsource/prompt/600.css";
// import "@fontsource/prompt/700.css";
import "./src/styles/global.css";
import React from "react";
import { GatsbyBrowser } from "gatsby";
import Layout from "./src/components/layout";
import { getLayoutProps } from "./gatsby-lib";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => {
  const layoutProps = getLayoutProps(element);
  return (
    <Layout {...props} {...layoutProps}>
      {element}
    </Layout>
  );
};
